import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_ACCESSES_LIST,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/access';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkAccess;
const cpmCarparkAccess = (state = initialSettings, action) => {
  // let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
        };
      }
      return state;
    // LIST
    case CPM_GET_CARPARK_ACCESSES_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ACCESSES_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ACCESSES_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listAccesses.entries),
            pageNumber: _parseInt(action.data.listAccesses.pageNumber),
            pageSize: _parseInt(action.data.listAccesses.pageSize),
            totalEntries: _parseInt(action.data.listAccesses.totalEntries),
            totalPages: _parseInt(action.data.listAccesses.totalPages),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkAccess;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkAccess.js